export default "/images/vendor/flag-icon-css/flags/1x1/am.svg?8752853c28f0a87ccefb8128bd51c142";